import { useMemo } from "react";
import PropTypes from "prop-types";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import rtlPlugin from "stylis-plugin-rtl";
import { useMaterialUIController } from "app/providers";
import light from "assets/theme";
import lightRtl from "assets/theme/theme-rtl";
import dark from "assets/theme-dark";
import darkRtl from "assets/theme-dark/theme-rtl";

// Include the auth provider's session warning and every portal in the active theme.
export default function AppThemeProvider({ children }) {
  const [{ darkMode, direction }] = useMaterialUIController();
  const rtlCache = useMemo(() => createCache({ key: "rtl", stylisPlugins: [rtlPlugin] }), []);
  const theme = direction === "rtl" ? (darkMode ? darkRtl : lightRtl) : darkMode ? dark : light;
  const content = (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
  return direction === "rtl" ? <CacheProvider value={rtlCache}>{content}</CacheProvider> : content;
}
AppThemeProvider.propTypes = { children: PropTypes.node.isRequired };
